<template>
    <div class="ProcessSubview">
        <QCard
            bordered
            class="ProcessSubviewCard"
        >
            <QCardSection class="q-pa-none">
                <QTabs
                    v-model="tab"
                    align="left"
                    dense
                    noCaps
                    inlineLabel
                    activeColor="primary"
                    indicatorColor="primary"
                    class="ToolsTabs text-grey-8"
                    @update:modelValue="handleTabChange"
                >
                    <QTab
                        name="ATTRS"
                        :label="$t('visualization.tabs.attributes')"
                        icon="pie_chart"
                    />
                    <QTab
                        name="DASHBOARD"
                        :label="$t('visualization.tabs.metrics')"
                        icon="bar_chart"
                    />
                    <QTab
                        name="COMPARISON"
                        :label="$t('visualization.tabs.contextComparison')"
                        icon="compare"
                    />
                </QTabs>

                <QTabPanels
                    v-model="tab"
                    animated
                >
                    <QTabPanel name="ATTRS">
                        <AttributeView
                            :processId="processId"
                            :projectId="$route.params.projectId"
                            :attributes="attributes"
                            :categoricalAttributes="categoricalAttributes"
                            :numericAttributes="numericAttributes"
                        />
                    </QTabPanel>
                    <QTabPanel name="DASHBOARD">
                        <DataNavigator
                            :processId="processId"
                        />
                    </QTabPanel>
                    <QTabPanel name="COMPARISON">
                        <ContextComparison
                            :processId="processId"
                            :filteredInfo="infoFiltered"
                        />
                    </QTabPanel>
                </QTabPanels>
            </QCardSection>
        </QCard>
    </div>
</template>

<script>
import VueTypes from 'vue-types'
import DataNavigator from '../AnalysisTools/sections/Metrics/DataNavigator.vue'
import AttributeView from '../AnalysisTools/sections/Attributes/AttributeView.vue'
import ContextComparison from '../AnalysisTools/sections/ContextComparison/ContextComparison.vue'

const DEFAULT_TAB = 'ATTRS'
const VALID_TABS = new Set(['ATTRS', 'DASHBOARD', 'COMPARISON'])

const ROUTE_TO_TAB = {
    ProcessAttributes: 'ATTRS',
    ProcessMetrics: 'DASHBOARD',
    ProcessComparisons: 'COMPARISON',
}

const TAB_TO_ROUTE = {
    ATTRS: 'ProcessAttributes',
    DASHBOARD: 'ProcessMetrics',
    COMPARISON: 'ProcessComparisons',
}

export default {
    name: 'AnalysisToolsSubview',
    components: {
        DataNavigator,
        AttributeView,
        ContextComparison,
    },
    props: {
        processId: VueTypes.any,
        infoFiltered: VueTypes.object,
        attributes: VueTypes.array,
        categoricalAttributes: VueTypes.array,
        numericAttributes: VueTypes.array,
        forcedTab: VueTypes.string,
        hideTabs: VueTypes.bool.def(false),
    },
    data() {
        return {
            tab: DEFAULT_TAB,
        }
    },
    watch: {
        '$route.fullPath': {
            handler() {
                const byRoute = ROUTE_TO_TAB[this.$route?.name]
                const byForced = this.forcedTab

                let next = DEFAULT_TAB
                if (VALID_TABS.has(byRoute)) next = byRoute
                else if (VALID_TABS.has(byForced)) next = byForced

                if (next !== this.tab) this.tab = next
            },
            immediate: true,
        },
    },
    methods: {
        handleTabChange(nextTab) {
            const tab = VALID_TABS.has(nextTab) ? nextTab : DEFAULT_TAB
            const targetRouteName = TAB_TO_ROUTE[tab] || 'ProcessAttributes'

            if (this.$route?.name === targetRouteName) return

            const nextQuery = { ...this.$route.query }
            delete nextQuery.tab

            this.$router.replace({
                name: targetRouteName,
                params: { ...this.$route.params },
                query: nextQuery,
            }).catch(() => {})
        },
    },
}
</script>

<style scoped lang="scss">
.ProcessSubview {
    height: 100%;
}

.ProcessSubviewCard {
    height: 100%;
}

.ToolsTabs {
    padding: 0 16px;

    :deep(.q-tab__label) {
        letter-spacing: 1.25px;
    }
}
</style>
